import { ComponentProps } from "react";
import { textFileTruncate } from "../../../utils/textFileTruncate";

interface FileContainerProps extends ComponentProps<"div"> {
    name: string;
    size: string | number;
    handleClick: () => void;
    type?: "remove" | "download";
}

export function getIconByExtension(filename: string) {
    const ext = filename.split(".").pop()?.toLowerCase();

    switch (ext) {
        case "pdf":
        return "/assets/svg/icon-pdf.svg";
        case "xml":
        return "/assets/svg/icon-xml.svg";
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
        return "/assets/svg/icon-img.svg";
        default:
        return "/assets/svg/icon-file.svg";
    }
}

export const FileContainer = ({
    handleClick,
    name,
    size,
    type = "remove",
}: FileContainerProps) => {
    return (
        <div
        title={name}
        className="rounded-sm border border-[#00000029] bg-gray-150 px-4 flex justify-center items-center h-16 gap-12"
        >
        <div className="flex gap-2 items-center">
            <img alt="icone de arquivo" src={getIconByExtension(name)} />
            <div className="flex flex-col text-[12px]">
            <span>{textFileTruncate({ limit: 10, text: name })}</span>
            <span>{size}</span>
            </div>
        </div>
        <img
            onClick={handleClick}
            className="cursor-pointer"
            src={
            type === "remove"
                ? "/assets/svg/icon-trash-red.svg"
                : "/assets/svg/icon-down-blue.svg"
            }
            alt="icone"
        />
        </div>
    );
};
